import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Auth0Provider } from '@/auth'
import { ProfileProvider } from '@/contexts/ProfileContext'
import { NotificationsProvider } from '@/contexts/NotificationsContext'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Auth0Provider>
      <ProfileProvider>
        <NotificationsProvider>
          <App />
        </NotificationsProvider>
      </ProfileProvider>
    </Auth0Provider>
  </StrictMode>,
)
